import React from 'react';
import { PlusIcon } from 'lucide-react';
import { DesignCard } from './DesignCard';
const mockDesigns = [{
  id: '1',
  name: '6" 5/8 GALV',
  type: 'Pivot Machine',
  desiredStock: 100,
  atHand: 65,
  incoming: 65,
  lowStock: 25,
  overStock: 54,
  covered: 11,
  orderRequired: 11
}, {
  id: '2',
  name: '8" 5/8 GALV',
  type: 'Pivot Machine',
  desiredStock: 30,
  atHand: 8,
  incoming: 13,
  lowStock: 32,
  overStock: 64,
  covered: 4,
  orderRequired: 0
}, {
  id: '3',
  name: '5" GALV',
  type: 'Pivot Machine',
  desiredStock: 20,
  atHand: 2,
  incoming: 0,
  lowStock: 23,
  overStock: 53,
  covered: 0,
  orderRequired: 18
}, {
  id: '4',
  name: 'High Profile',
  type: 'Pivot Machine',
  desiredStock: 20,
  atHand: 22,
  incoming: 0,
  lowStock: 16,
  overStock: 65,
  covered: 0,
  orderRequired: 0
}, {
  id: '5',
  name: 'Linear',
  type: 'Linear',
  desiredStock: 15,
  atHand: 1,
  incoming: 0,
  lowStock: 42,
  overStock: 8,
  covered: 0,
  orderRequired: 14
}, {
  id: '6',
  name: '6" 5/8 POLY',
  type: 'Pivot Machine',
  desiredStock: 25,
  atHand: 5,
  incoming: 3,
  lowStock: 35,
  overStock: 45,
  covered: 8,
  orderRequired: 12
}];
export function StockDesigns() {
  const consolidated = {
    atHand: 65,
    incoming: 65,
    lowStock: 20,
    overStock: 60,
    covered: 5,
    orderRequired: 14
  };
  return <div className="space-y-6" data-id="element-354">
      <div className="flex items-center justify-between" data-id="element-355">
        <h2 className="text-xl font-bold text-gray-900" data-id="element-356">Stock by Design</h2>
        <button className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" data-id="element-357">
          <PlusIcon className="w-5 h-5" data-id="element-358" />
          Create Template
        </button>
      </div>
      <DesignCard design={{
      id: 'consolidated',
      name: 'Stock Consolidated',
      type: 'All Designs',
      desiredStock: 0,
      atHand: consolidated.atHand,
      incoming: consolidated.incoming,
      lowStock: consolidated.lowStock,
      overStock: consolidated.overStock,
      covered: consolidated.covered,
      orderRequired: consolidated.orderRequired
    }} isConsolidated data-id="element-359" />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-360">
        {mockDesigns.map(design => <DesignCard key={design.id} design={design} data-id="element-361" />)}
      </div>
    </div>;
}